// Styles here will override Bulma styles
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import media from 'css-in-js-media';

export const styledCardsSection = css`
  background-repeat: repeat;
`;

export const styledCardsContainer = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${media('<desktop')} {
    h2,
    p {
      max-height: 200px;
      margin-left: 20px;
      margin-right: 20px;
      text-align: center;
      overflow: hidden;
    }
  }
`;

export const styledHeading = css`
  text-align: left;
`;

export const styledSubtitle = css`
  margin: 20px auto 80px 0 !important;
  max-width: 670px;
  text-align: left;
`;

export const styledCards = css`
  display: grid;
  grid-auto-flow: dense;
  grid-auto-rows: 1fr;
  grid-gap: 32px;
  max-width: 1168px;

  ${media('<desktop')} {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

export const styledCardBox = css`
  background: #fff;
  border: 1px solid #e5e8ed;
  border-radius: 5px;
  padding: 24px;
  margin-bottom: 0 !important;
  box-shadow: none;

  ${media('<desktop')} {
    margin-top: 32px;
  }
`;

export const styledCardBoxLink = css`
  background: #fff;
  border: 1px solid #e5e8ed;
  border-radius: 5px;
  padding: 24px 24px 16px 24px;
  margin-bottom: 0 !important;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(3, 27, 78, 0.06) !important;
  transition: all 0.5s ease;

  :hover {
    box-shadow: 0 10px 20px rgba(3, 27, 78, 0.1) !important;
    transform: scale(1.01);
    background-color: #fff !important;
  }

  ${media('<desktop')} {
    margin-top: 32px;
  }
`;

export const StyledFilterContainer = styled.select`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; /* Remove default arrow */

  width: 270px;
  height: 48px;
  border-radius: 3px;
  border: 1px solid #e5e8ed;

  font-weight: 600;
  font-family: 'WorkSans-Regular';
  font-style: normal;
  font-weight: normal;

  p {
    margin-left: 16px;
    margin-top: 12px;
  }
`;

export const styledCardContent = css`
  position: relative;
  height: 100%;

  .title {
    margin-top: 15px;
  }

  a {
    color: #0069ff;
    font-family: 'WorkSans-Bold', 'Helvetica', 'sans-serif';
    font-style: normal;
  }

  ${media('<= desktop')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const styledCardImageOnly = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
`;

export const styledButton = css`
  margin-top: 60px;
  margin-bottom: 40px;
`;

export const StyledCardText = styled.div`
  p {
    color: ${props => props.color};
  }
`;

export const StyledNavContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media('<tablet')} {
    flex-direction: column;
  }
`;
